<template>

  <div class="cart-wrapper" v-show="currentCart && notBenchmark">

    <!-- Cart Header -->
    <div class="cart-header-banner">
      <img :src="brandImg" alt="">
    </div>

    <!-- Cart Summary Wrapper -->
    <div class="cart-summary-wrapper">

      <!-- Summary of products -->
      <div class="cart-products-summary-wrapper">
        <div class="cart-product-detail" v-for="product in currentProducts">

          <span class="cart-product-image-wrapper">
            <img class="cart-product-image" :src="product['product-images'][0]"/>
          </span>

          <span class="cart-product-name">
            {{ product.name }}
          </span>

          <span class="cart-product-price">
            ${{ product.price }}
          </span>
        </div>
      </div>

      <!-- Cart Summary Heading -->
      <div class="cart-summary-heading">
        Loading product on {{ currentBrand && currentBrand.brandName }}
      </div>

      <div class="loading-wrapper">
        <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"></i>
      </div>

    </div>


    <div id="iframe-cart-holder"></div>
  </div>
</template>

<script>

  import cartManager from '../lib/cartManager'

  export default {
    props: [],
    data() {
      return {
        notBenchmark: false
      }
    },
    components: {},
    mounted() {
      this.initMagicCart()
    },
    computed: {
      brandImg() {
        if (!this.currentBrand) return ''
        let brandName = this.currentBrand.brandName
        if (brandName == 'Dr. Brandt') return '//mikmak.s3.amazonaws.com/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/dr-brandt.png'
        if (brandName == 'NutriBullet') return '//nutriliving-images.imgix.net/images/logos/logo.svg'
        return ''
      },
      trafficType() {
        let type =  this.$route.params.trafficType
        if (type == 'p') return 'paid'
        return 'organic'
      },
      platform() {
        let platform = this.$route.params.platform
        if (platform == 's') return 'snapchat'
        return 'instagram'
      },
      cartId() {
        return this.$route.params.cartId
      },
      currentCart() {
        return this.$store.state.carts[this.cartId]
      },
      currentBrand() {
        if (!this.currentCart) return
        return this.currentCart.brand
      },
      currentProducts() {
        if (!this.currentCart) return
        return this.currentCart.products
      },
      currentProduct() {
        return this.currentProducts && this.currentProducts[0]
      }
    },
    methods: {
      initMagicCart() {

        // Divert 10% of traffic directly to product page.
        let randomOneThroughTen = this.random()
        if (randomOneThroughTen == 1 && !this.isTest()) return this.benchmarkTraffic()
        this.notBenchmark = true
        cartManager.createAndAppendFormToIframe(this.currentProduct, this.currentBrand, this.utmStandard(), this.eventObject())
      },
      benchmarkTraffic() {
        let baseUrl = this.currentProduct.productUrl
        let utm = this.utmForBenchmark()
        let url = `${baseUrl}${utm}`
        this.goToUrl(url)
      },
      eventObject() {
        return {
          cartId: this.cartId,
          trafficType: this.trafficType,
          platform: this.platform
        }
      },
      goToUrl(url) {
        if (!amplitude) {
          let self = this
          setTimeout(() => {
            self.goToUrl(url)
          }, 100)
          return
        }

        let name = 'CART_LOADED_BENCHMARK'
        amplitude.getInstance().logEvent(name, this.eventObject(), () => {
          window.location = url
        });
      },
      utmForBenchmark() {
        let utm = `?utm_source=mikmak-magic-benchmark&utm_campaign=${this.platform}_${this.trafficType}_${this.cartId}`
        if (this.isTest()) utm = ''
        return utm
      },
      utmStandard() {
        let utm = `?utm_source=mikmak-magic&utm_campaign=${this.platform}_${this.trafficType}_${this.cartId}`
        if (this.isTest()) utm = ''
        return utm
      },
      isTest() {
        return window.location.search.indexOf('testmagic') != -1
      },
      random() {
        // Returns random number 1-10.
        return Math.floor(Math.random() * 10) + 1
      }
    },
    watch: {}
  }

</script>

<style scoped>

  .cart-wrapper {
    display: block;
    margin: 48px auto;
    width: 500px;
    background: rgba(255, 255, 255, 0.49);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.13);
    border-radius: 3px;
    overflow: hidden;
  }

  @media only screen and (max-width: 750px) {
    .cart-wrapper {
      max-width: 90%;
      margin-top: 5%;
    }
  }

  .cart-header-banner {
    display: block;
    /*background-image: url('../assets/header-banner.png');*/
    width: 100%;
    height: 200px;
    background-position: center center;
    background-size: 175%;
  }

  .cart-header-banner img {
    display: block;
    height: 100%;
    width: auto;
    margin: 0 auto;
    max-width: 350px;
  }

  .cart-circle {
    display: block;
    height: 50px;
    width: 50px;
    background: #f8f8f8;
    margin: 0 auto;
    margin-top: -20px;
    border-radius: 99px;
  }

  .current-brand-name {
    font-weight: bold;
    text-decoration: underline;
  }

  .cart-summary-heading {
    display: block;
    font-size: 16px;
    width: 232px;
    margin: 0 auto;
  }

  .loading-wrapper {
    margin: 12px;
    color: #20ca86;
  }

  .cart-product-detail {
    display: block;
    width: 80%;
    border: 1px solid rgba(0, 0, 0, 0.14);
    margin: 0px auto;
    margin-bottom: 48px;
    padding: 12px;
    border-radius: 3px;
    font-size: 14px;
  }

  .cart-product-image-wrapper {
    display: block;
    margin: 0 auto;
    width: 100%;
    text-align: center;
  }

  .cart-product-image {
    padding: 8px;
    border-radius: 3px;
    background: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.17);
    width: 50px;
    margin-bottom: 12px;
  }

  .cart-product-name {

  }

  .cart-product-price {
    margin-left: 12px;

  }

</style>



// WEBPACK FOOTER //
// CartSummary.vue?4f72c8a2